import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface CTAButtonProps {
  children?: React.ReactNode;
  className?: string;
  variant?: 'orange' | 'white';
  href?: string;
  showIcon?: boolean;
  animated?: boolean;
}
const VARIANTS: Record<string, string> = {
  orange: 'bg-brand-orange text-white hover:bg-[#d1521e] focus-visible:ring-brand-orange',
  white: 'bg-white text-brand-navy hover:bg-brand-main focus-visible:ring-white'
};
export function CTAButton({
  children = 'Jetzt das Kunst-Paket sichern',
  className = '',
  variant = 'orange',
  href = '#angebot',
  showIcon = true,
  animated = false
}: CTAButtonProps) {
  return <a href={href} className={`inline-flex w-full items-center justify-center gap-2 rounded-full px-8 py-4 text-xs font-extrabold uppercase tracking-[0.12em] shadow-md transition-shadow duration-200 ease-out hover:shadow-lg focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 sm:w-auto sm:text-sm ${VARIANTS[variant]} ${animated ? 'cta-attention' : ''} ${className}`} data-id="element-46" data-mp="33oe77dhuuotl">
      {children}
      {showIcon && <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-47" data-mp="1da893bktpxb7" />}
    </a>;
}